import Vue from 'vue';
import { basicUtils } from '../utils/utils';

Vue.filter('timestampToDate', (value) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${day}/${month}/${year}`;
});

Vue.filter('timestampToTime', (value) => {
  const date = new Date(value);
  const hours = date.getHours();
  const minutes = `0${date.getMinutes()}`;
  const seconds = `0${date.getSeconds()}`;

  return `${hours}:${minutes.substr(-2)}:${seconds.substr(-2)}`;
});

/* eslint-disable */
Vue.filter('concatenateDateAndTime', (value) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hours = date.getHours();
  const minutes = `0${date.getMinutes()}`;
  const seconds = `0${date.getSeconds()}`;
  const dayLitteral = basicUtils.dayOfTimestamp(value);

  return `${dayLitteral}: ${day}/${month}/${year} à ${hours}:${minutes.substr(-2)}:${seconds.substr(-2)}`;
});
